module.exports = __webpack_public_path__ + "img/bed.0e56b6ce.png";